import request from '@/utils/request'

// 创建/获取客服会话（页面自带连接中状态，不弹全局加载中）
// merchantId：0（或不传）= 商城官方客服；其它为对应商家店铺客服
export const createChatSessionApi = (merchantId = 0) => {
  return request.post('/chat/createSession', { merchantId }, { silent: true })
}

// 聊天入口列表：官方客服 + 各商家店铺客服（商城「聊天」Tab 使用）
export const getChatMerchantsApi = () => {
  return request.get('/chat/merchants', { silent: true })
}

// 用户发送消息（msgType: 1=文本 2=图片）
export const sendChatMessageApi = (sessionId, content, msgType = 1) => {
  return request.post('/chat/send', {
    sessionId,
    content,
    msgType
  })
}

// 上传聊天图片，返回 { url }
export const uploadChatImageApi = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 拉取消息（增量）— 高频轮询，不弹加载中
// markRead=1 仅在聊天页使用：拉取即视为用户已读，推进服务端「买家已读游标」（客服端消息回执用）
export const getChatMessagesApi = (sessionId, after = 0, markRead = 0) => {
  return request.get(`/chat/messages?sessionId=${sessionId}&after=${after}&markRead=${markRead ? 1 : 0}`, { silent: true })
}

// 我的会话列表 — 高频轮询，不弹加载中
export const getChatSessionsApi = () => {
  return request.get('/chat/sessions', { silent: true })
}

// 未读客服消息总数（底部导航「消息」红标）— 高频轮询，不弹加载中；未登录时返回 0
export const getChatUnreadApi = () => {
  return request.get('/chat/unread', { silent: true })
}

// 撤回消息（仅限自己发送且 2 分钟内的消息）
export const revokeChatMessageApi = (messageId) => {
  return request.post('/chat/revoke', { messageId })
}
